// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"3b1b6b9f","121":"e19f76df","479":"25a5f28a","849":"a8b4089c","881":"fa4d2afa"}[chunkId] + ".chunk.js";
};